import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter  } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from './store'
import Theme from 'components/template/Theme'
import Layout from 'components/layout'
import history from './history'
// import appConfig from 'configs/app.config'
import './locales'

const environment = process.env.NODE_ENV

function App() {
	return (
		<HelmetProvider>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<BrowserRouter history={history}>
						<Theme>
							<Layout />
						</Theme>
					</BrowserRouter >
				</PersistGate>
			</Provider>
		</HelmetProvider>
	)
}

export default App
